package com.milta.core.localization.translations.de

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Datei importieren",
    analysingTitle = "Datei wird analysiert…",
    analysingSubtitle = "Wir identifizieren die Spalten und erkennen die Zustellungen in der Tabelle.",
    fileSentSuffix = "gerade gesendet",
    structuredFormatBannerTitle = "Format erkannt.",
    structuredFormatBannerMessage = "Die Spalten wurden automatisch zugeordnet, keine Korrektur nötig.",
    columnsInterpretedBannerTitle = "Spalten automatisch interpretiert.",
    columnsInterpretedBannerMessage = "Überprüfen Sie die markierten Zustellungen, bevor Sie sie hinzufügen.",
    completePillLabel = "Alles vollständig",
    invalidFileTitle = "Datei nicht unterstützt.",
    invalidFileMessage = "Importieren Sie eine gültige Excel- (.xlsx) oder CSV-Datei (.csv).",
    chooseAnotherFileButton = "Andere Datei wählen",
    extractionFailedTitle = "Diese Datei kann nicht gelesen werden.",
    extractionFailedMessage = "Die Tabelle scheint leer zu sein oder ihre Struktur wurde nicht erkannt — überprüfen Sie den Inhalt oder erfassen Sie die Zustellungen manuell.",
    retryWithNewFileButton = "Mit anderer Datei erneut versuchen",
    serviceUnavailableTitle = "Analysedienst vorübergehend nicht verfügbar.",
    serviceUnavailableMessage = "Versuchen Sie es in ein paar Momenten erneut, oder vervollständigen Sie diese Zustellung in der Zwischenzeit manuell.",
)
